import axios from 'axios'
import Swal from 'sweetalert2'
import https from 'https';

export default function (options = {}) {
    const client = axios.create();
    client.defaults.httpsAgent = new https.Agent({
        keepAlive: true,
        requestCert: true,
        rejectUnauthorized: true,
    });

    client.interceptors.response.use(function (response) {

        return response

    }, function (error) {

        let message = ''

        const { status } = error?.response || {}

        if (status === 419) {
            Swal.fire({
                title: 'Logged out',
                icon: 'info',
                confirmButtonColor: '#0db4e6',
                confirmButtonText: 'Click me to Sign In'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = "/"
                }
            })

            return Promise.reject(error)
        }

        if (error.response?.data?.errors) {

            const keys = Object.keys(error.response.data.errors)

            for (let i = 0; i < keys.length; i++) {
                const value = error.response.data.errors[keys[i]][0]

                message += `${value}<br/>`
            }

        } else if (error.response?.data?.message) {
            message = error.response.data.message
        } else if (error.message) {
            message = error.message
        }

        if (message.includes('No query results for model')) {
            return Promise.reject(error);
        }

        if (error.response.status !== 401) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                html: message,
            })
        }

        return Promise.reject(error)
    })

    return client
}
